import type { CurrentProcessingStatusResponse, ProcessingStepType } from '../generated/generatedOpenAPI';

const STEP_LABELS: Record<ProcessingStepType, string> = {
  processing: 'Processing',
  concatenation: 'Concatenation',
  reannotation: 'Reannotation',
  numbering: 'Numbering',
  shm: 'Hypermutation analysis',
  liabilities: 'Liability analysis',
  ranking: 'Ranking',
  clonotyping: 'Clonotyping',
  cancel: 'Cancelling',
};

export function formatProgressStatus(data: CurrentProcessingStatusResponse | null | undefined): string | null {
  if (!data || (data.stepIndex === null && data.processingStep !== 'processing')) {
    return null;
  }

  const stepLabel = STEP_LABELS[data.processingStep] ?? data.processingStep;

  if (data.processingStep === 'processing' && data.stepIndex === null) {
    return `Running step ${data.totalStepCount} of ${data.totalStepCount}: ${stepLabel}`;
  }

  return `Running step ${data.stepIndex} of ${data.totalStepCount}: ${stepLabel}`;
}

export function formatFailureStatus(data: CurrentProcessingStatusResponse | null | undefined): string {
  // The payload can describe a step that was still running, so only name a step the backend
  // actually reported as failed.
  if (!data || data.processingStepStatus !== 'failed') {
    return 'Analysis failed';
  }

  const stepLabel = STEP_LABELS[data.processingStep] ?? data.processingStep;
  const stepPrefix = data.stepIndex != null ? `Step ${data.stepIndex} of ${data.totalStepCount} ${stepLabel} failed` : `${stepLabel} failed`;

  return data.error ? `${stepPrefix}: ${data.error}` : stepPrefix;
}
